export default __webpack_public_path__ + "static/media/vaNoMsgsImgDefault.543667ec.png";